import React from "react";
import { Htmlskill } from "../common/Assetsmanger";
import { Cssskill } from "../common/Assetsmanger";
import { Jsskill } from "../common/Assetsmanger";
import { Bootskill } from "../common/Assetsmanger";
import { Reactskill } from "../common/Assetsmanger";
import { Gitskill } from "../common/Assetsmanger";
import { Tailskill } from "../common/Assetsmanger";
import { JQskill } from "../common/Assetsmanger";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";
function Skillscom() {
  return (
    <div className="pad-section ">
      <div className="text-white text-center">
        <div className="sub-headingpad">
          <h2 className="w-5/5 lg:w-3/5 mx-auto font-bold">Technical Proficiencies</h2>
        </div>
        <div className="flex flex-wrap gap-16 justify-center hidden lg:flex">
          <div className="basis-2/12  flex flex-col items-center justify-around  skill-cardshadow pad-top pad-bottom">
            <img src={Htmlskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">HTML</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Cssskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">CSS</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Jsskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">JavaScript</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Bootskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">Bootstrap</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Reactskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">React</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Gitskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">Git</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={Tailskill} className="w-5/12" />
            <h6 className="pad-top font-semibold">Tailwind CSS</h6>
          </div>
          <div className="basis-2/12  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
            <img src={JQskill} className="w-5/12" />
            <h6 className=" pad-top font-semibold">jQuery</h6>
          </div>
        </div>
        <div className="lg:hidden">
          <Swiper
            slidesPerView={2}
            loop={true}
            centeredSlides={true}
            spaceBetween={30}
            grabCursor={true}
            autoHeight={true}
            breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                600: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
              }}
            className="mySwiper skillswiper  "
          >
            <SwiperSlide>
              <div className=" flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Htmlskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">HTML</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={JQskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">jQuery</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className=" flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Cssskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">CSS</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Gitskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">Git</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Tailskill} className="w-8/12" />
                <h6 className="pad-top font-semibold">Tailwind CSS</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Bootskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">Bootstrap</h6>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="  flex flex-col items-center justify-around skill-cardshadow pad-top pad-bottom">
                <img src={Reactskill} className="w-8/12" />
                <h6 className=" pad-top font-semibold">React</h6>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default Skillscom;
